export function Plan() {
    return (
        <div>Plan </div>

    )
}